import { useEnsureDemoPatients } from '@/entities/sandbox-demo';

export function SandboxDemoEnsureOnce() {
  useEnsureDemoPatients();
  return null;
}
